import React from 'react';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { TooltipPlacement } from 'antd/lib/tooltip';
import styles from './index.module.scss';

interface TooltipProps {
  children?: React.ReactChild;
  style?: React.CSSProperties;
  title?: React.ReactNode | (() => React.ReactNode);
  placement?: TooltipPlacement;
}

export default function TooltipBase({ style, title, placement = 'right', children }: TooltipProps) {
  return (
    <Tooltip title={title} overlayClassName={styles.tooltip} placement={placement}>
      {children ? (
        { children }
      ) : (
        <svg className={classNames(styles.tooltipIcon, 'icon')} aria-hidden={true} style={style}>
          <use xlinkHref="#icon-info_tip" />
        </svg>
      )}
    </Tooltip>
  );
}
